import { computeBizAmount } from './bizAmount'
import { computeOtherFee } from './otherFee'

export function buildFeeSummary (base, coupon, policy) {
  const amountContext = {
    ...base.amountContext,
    currCoupon: coupon.currCoupon,
  }
  const otherFee = computeOtherFee(amountContext)
  const sharedAmount = computeBizAmount(amountContext, {
    couponBeforeTimeAndTax: policy.couponBeforeTimeAndTax,
  })

  return {
    base,
    coupon,
    amountContext,
    otherFee,
    legacyAmount: policy.legacyAmount,
    sharedAmount,
  }
}

export default buildFeeSummary
